import { render, staticRenderFns } from "./DeleteCoupon.vue?vue&type=template&id=c45ece7a&scoped=true"
import script from "./DeleteCoupon.vue?vue&type=script&lang=js"
export * from "./DeleteCoupon.vue?vue&type=script&lang=js"
import style0 from "./DeleteCoupon.vue?vue&type=style&index=0&id=c45ece7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45ece7a",
  null
  
)

export default component.exports